import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as dataHelper from '../../../helpers/dataHelper';

import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiResultReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            kpiDefaults: this.props.kpiDefaults,
            kpi: props.kpi,
            currentScoreRange: {
                class: ""
            },
            showPointsIndicator: false,
            locale: {},
            guid: dataHelper.createGuid(),
            updateScoreRange: false,
        };

        this.getLocale = this.getLocale.bind(this);
        this.setCurrentScoreRange = this.setCurrentScoreRange.bind(this);

    }

    componentDidMount() {

        this.getLocale();
        this.setCurrentScoreRange();

    }

    componentWillReceiveProps(nextProps){
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpiDefaults)
            });
        }

        if(this.state.kpi !== nextProps.kpi){
            this.setState({
                kpi: Object.assign({},nextProps.kpi),
                updateScoreRange: true,
            });
        }
    }

    componentDidUpdate(){
        if(this.state.updateScoreRange){
            this.setCurrentScoreRange();
        }
    }

    getLocale() {
        this.setState({locale: appHelper.getLocalData(this.state.kpiDefaults)});
    }

    setCurrentScoreRange(){
        this.setState({
            updateScoreRange: false,
        });
        if(appHelper.isDefined(appHelper.isDefined(this.state.kpi))){
            let currentScoreRange = {};
            if(appHelper.isDefined(this.state.kpi.kpi_id)){
                currentScoreRange = kpiHelper.getKpiPointsIndicatorClass(this.state.kpi.value, this.state.kpi.kpi_id);
            }else {
                currentScoreRange = kpiHelper.getKpiPointsIndicatorClass(this.state.kpi.value, this.state.kpiDefaults.kpi_id);
            }
            this.setState({
                currentScoreRange: Object.assign({},currentScoreRange),
            });
        }
    }

    render() {
        return (
                appHelper.isDefined(this.props.kpi)
                ?
                    <div className={`kpi-points-review-awarded guroo-kpi-label ${this.state.currentScoreRange.class}`}>
                        <div className="kpi-result"/>
                        {this.state.locale.long_title}
                    </div>
                :
                    null
        );
    }
}

KpiResultReview.propTypes = {
    kpiDefaults: PropTypes.object.isRequired,
    meterParams: PropTypes.object,
    kpi: PropTypes.object,
    lang: PropTypes.string.isRequired,

};

KpiResultReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KpiResultReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiResultReview.js
 **/